import { render, staticRenderFns } from "./RentingEntities.vue?vue&type=template&id=9b24974a&"
import script from "./RentingEntities.vue?vue&type=script&lang=ts&"
export * from "./RentingEntities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports